import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-involved-staff-field',
  standalone:false,
  templateUrl: './involved-staff-field.component.html',
  styleUrls: ['./involved-staff-field.component.scss'],
})
export class InvolvedStaffFieldComponent implements OnInit {

  @Input() pageSpecificFormObject;
  @Input() staffListMaster;
  @Input() staffList;
  @Input() staffListInvolded;
  @Input() canUpdate;

  constructor() { }

  ngOnInit() {}




  inchargeUsersChanged(event)  {
    console.log(event.target.value);
    const selectedIncharge = event.target.value;
    let selectedIds = [];
    if (selectedIncharge) {
      selectedIncharge.forEach(id => {
        if (!selectedIds.includes(parseInt(id))) {
          selectedIds.push( parseInt(id));
        }
      });
    }

    if (this.pageSpecificFormObject.inchargeUserIds) {
      this.pageSpecificFormObject.inchargeUserIds.forEach(id => {
        if (!selectedIds.includes(parseInt(id))) {
          selectedIds.push( parseInt(id));
        }
      });
    }

    if (selectedIds.length === 0) {
      this.staffListInvolded = this.staffListMaster;
      this.staffList = this.staffListMaster;
    } else {
      this.staffListInvolded = this.staffListMaster.filter(staff => {
        return !selectedIds.includes(parseInt(staff.id));
      });
    }
  }

  involvedUsersChanged(event)  {
    console.log(event.target.value);
    const selectedInvolved = event.target.value;
    let selectedIds = [];
    if (selectedInvolved) {
      selectedInvolved.forEach(id => {
        if (!selectedIds.includes(parseInt(id))) {
          selectedIds.push( parseInt(id));
        }
      });
    }

    if (this.pageSpecificFormObject.involvedUserIds) {
      this.pageSpecificFormObject.involvedUserIds.forEach(id => {
        if (!selectedIds.includes(parseInt(id))) {
          selectedIds.push( parseInt(id));
        }
      });
    }

    if (selectedIds.length === 0) {
      this.staffListInvolded = this.staffListMaster;
      this.staffList = this.staffListMaster;
    } else {
      this.staffList = this.staffListMaster.filter(staff => {
        return !selectedIds.includes(parseInt(staff.id));
      })
    }
  }
}
